<template>
  <BModal :model-value="modal" scrollable centered title="Extracharge" @update:modelValue="updateModal"> 
    <template #header>
        <div class="d-flex align-items-center justify-content-between modal-title w-100">
            <h5 class="">Extracharge</h5>
        </div>
        <BButton
            variant="link"
            class="close"
            @click="updateModal(false)"
        >
            <i class="ion ion-android-close"></i>
        </BButton>
    </template>
    <BForm>
      <div class="form-group">  
        <BFormSelect v-model="selectCategory" :options="categories" class="">
            <template #first>
                <BFormSelectOption :value="null" disabled>Select category</BFormSelectOption>
            </template>
        </BFormSelect>
      </div>
      <div class="form-group">  
       <BFormInput placeholder="Name">

       </BFormInput>
      </div>
      <div class="form-group">  
       <BFormInput placeholder="Price">

       </BFormInput>
      </div>
      <div class="form-group">  
       <!-- <BFormInput placeholder="Quantity">
       </BFormInput> -->
      </div>
    </BForm>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="submitReservation" class="mr-2">Save</BButton>
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
</template>

<script>
import { ref } from "vue";
import {
    BModal,
    BButton,
    BForm,
    BFormInput,
    BFormSelect,
    BFormSelectOption
} from "bootstrap-vue-next";

export default {
    components: {
        BModal,
        BButton,
        BForm,
        BFormInput,
        BFormSelect,
        BFormSelectOption
    },
    emits: ["update:modal"],
    props: {
          modal: Boolean,
    },
    setup(props, {emit}){
        console.log(props)
        const categories = ref([
          { text:'Resto'}, 
          { text:'Hotel'}, 
          { text:'Travel'}
        ])
        const selectCategory = ref(null)
        const updateModal = (value) => {
          emit("update:modal", value); // Sync modal state with parent
        };
        return{
            updateModal,
            selectCategory,
            categories
        }
    }
}
</script>

<style>

</style>